﻿import React from 'react'

// state 
import { connect } from 'react-redux';
import { fetchPossessionsData, fetchMetaData } from '../State/actions';

const PossessionsData = ({  children, ...props }) => {

    React.useEffect(() => {
        props.loadPossessions();
    }, []);

    React.useEffect(() => {
        props.loadMetaData(); 
    }, []);

    let possessions = props.possessionsData.possessions;
    let metaData = props.metaData;
    let monthlyPremium = props.possessionsData.monthlyPremium;
    let combined = [];
    let future = [];
    let current = [];
    const today = new Date();
    let currentDate = '';

    if (today !== null) {
        currentDate = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + (today.getDate())).slice(-2);
    }

    if (possessions && possessions.length > 0) {
        combined = possessions.map(item => ({
            ...item,
            metaData: metaData.meta.filter(f => f.groupName === item.productGroupName)
        }));

        //maps through the combined array to separate current from future possessions
        combined.length > 0 && combined.map(item => {
            
            if (item.fromDate <= currentDate) {
                current.push(item)
            }

            if (item.fromDate > currentDate) {
                future.push(item)
            }          
        })

    }

    

    return (
        <React.Fragment>
            {React.cloneElement(children, { combined: combined, monthlyPremium: monthlyPremium, future: future, current: current })}
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        possessionsData: state.possessionsData,
        metaData: state.metaData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadPossessions: (possessionsData) => dispatch(fetchPossessionsData(possessionsData)),
        loadMetaData: (metaData) => dispatch(fetchMetaData(metaData))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PossessionsData);